import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Formik } from 'formik';
import { withRouter } from 'react-router-dom';
import { Mutation, withApollo } from 'react-apollo';
import { fill, flatten } from 'lodash';
import LotModalFormMultiple from '~/components/lotModalForm/lotModalFormMultiple';
import { lotMultipleValidationSchema } from '~/validation/lot';

export const createLotMutation = gql`
  mutation createLots(
    $breweryId: Int!
    $transferScheduleId: Int!
    $volume: Int!
    $isSample: Boolean!
    $startDate: String!
    $productIds: [Int!]
  ) {
    createLots(
      breweryId: $breweryId
      transferScheduleId: $transferScheduleId
      volume: $volume
      isSample: $isSample
      startDate: $startDate
      productIds: $productIds
    ) {
      id
    }
  }
`;

const LotCreateMultiple = ({ brewery, defaultLotVolume, isOpen, onToggle, client, history }) => (
  <Modal isOpen={isOpen} toggle={onToggle}>
    <Mutation mutation={createLotMutation}>
      {createLots => (
        <Fragment>
          <ModalHeader toggle={onToggle}>Schedule new lots</ModalHeader>
          <Formik
            initialValues={{
              isSample: false,
              volume: defaultLotVolume,
              products: [
                {
                  id: null
                }
              ]
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={lotMultipleValidationSchema}
            onSubmit={async (values, { setErrors, setSubmitting }) => {
              try {
                const valuesToSubmit = { ...values };
                valuesToSubmit.productIds = flatten(
                  values.products.map(p => {
                    const arr = new Array(p.amount ? parseInt(p.amount, 10) : 1);
                    fill(arr, p.id);
                    return arr;
                  })
                );
                delete valuesToSubmit.products;

                await createLots({
                  variables: {
                    ...valuesToSubmit,
                    breweryId: brewery.id
                  },
                  awaitRefetchQueries: true,
                  refetchQueries: ['lots']
                });
                history.push(`/lots?new_multiple=${valuesToSubmit.productIds.length}`);
                onToggle();
              } catch (err) {
                setErrors({
                  unknown: 'An unknown error occured'
                });
                setSubmitting(false);
              }
            }}
            render={props => <LotModalFormMultiple {...props} onCancelClick={onToggle} />}
          />
        </Fragment>
      )}
    </Mutation>
  </Modal>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery,
    defaultLotVolume: state.brewery.settings.defaultLotVolume
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(LotCreateMultiple)));



// WEBPACK FOOTER //
// ./src/containers/lotCreate/createMultiple.jsx